import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../../stores/authStore";
import logo from "../../../assets/logo.png";

export default function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuthStore();
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        const success = await login(email, password);
        setLoading(false);

        if (success) {
            navigate("/admin");
        } else {
            setError("Invalid email or password");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-secondary relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5">
                <div className="absolute inset-0" style={{
                    backgroundImage: `repeating-linear-gradient(
                        0deg,
                        transparent,
                        transparent 50px,
                        rgba(255,255,255,0.03) 50px,
                        rgba(255,255,255,0.03) 51px
                    ), repeating-linear-gradient(
                        90deg,
                        transparent,
                        transparent 50px,
                        rgba(255,255,255,0.03) 50px,
                        rgba(255,255,255,0.03) 51px
                    )`
                }} />
            </div>

            {/* Login Card */}
            <div className="relative z-10 w-full max-w-md p-10 bg-white shadow-2xl border-t-4 border-primary">
                {/* Logo */}
                <div className="flex justify-center mb-8">
                    <img src={logo} alt="HESN Development" className="h-16 w-auto" />
                </div>

                {/* Title */}
                <div className="text-center mb-8">
                    <h1 className="font-display text-2xl font-bold tracking-tight uppercase text-secondary mb-2">
                        Admin Portal
                    </h1>
                    <p className="text-text-muted text-sm">
                        Sign in to manage your content
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    {error && (
                        <div className="p-4 bg-red-50 border-l-4 border-red-500 text-red-700 text-sm">
                            {error}
                        </div>
                    )}

                    <div>
                        <label className="block text-sm font-semibold text-secondary uppercase tracking-wide mb-2">
                            Email
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-3 rounded-hesn border-2 border-accent/30 bg-surface focus:outline-none focus:border-primary transition-colors"
                            placeholder="admin@elhesn.com"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-secondary uppercase tracking-wide mb-2">
                            Password
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-4 py-3 rounded-hesn border-2 border-accent/30 bg-surface focus:outline-none focus:border-primary transition-colors"
                            placeholder="••••••••"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full py-4 px-6 bg-secondary text-white font-display font-bold uppercase tracking-wider rounded-hesn hover:bg-primary-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? "Signing in..." : "Sign In"}
                    </button>
                </form>

                {/* Footer */}
                <div className="mt-8 pt-6 border-t border-accent/20 text-center">
                    <p className="text-text-muted text-xs uppercase tracking-wide">
                        HESN Development — حصنك للاستثمار العقاري
                    </p>
                </div>
            </div>
        </div>
    );
}
